import {
  Datasource_BronzeTable,
  DetectionRule_StreamTable,
  Transform_StreamTable,
} from '@/types/api';
import { StreamTableSchemaValues } from '@/zod/schemas/StreamTableSchema';

type JoinType = StreamTableSchemaValues['joinType'];

export const getStreamTablesValues = (
  tables: (Datasource_BronzeTable | Transform_StreamTable)[],
  override?: Partial<StreamTableSchemaValues>,
): StreamTableSchemaValues[] => {
  return tables.map((table, index) => ({
    streaming: table.streaming ?? false,
    name: table.name ?? '',
    watermark: {
      eventTimeColumn: table.watermark?.eventTimeColumn ?? '',
      delayThreshold: table.watermark?.delayThreshold ?? '',
      dropDuplicates: table.watermark?.dropDuplicates ?? [''],
    },
    alias: table.alias ?? '',
    joinHidden: index === 0,
    joinType: (table.joinType || '') as JoinType,
    joinExpr: table.joinExpr ?? '',
    aliasRequired: index === 0 && (tables?.length || 0) > 1,
    ...override,
  }));
};

export const setStreamTablesValues = <
  T extends
    | Datasource_BronzeTable
    | Transform_StreamTable
    | DetectionRule_StreamTable,
>(
  values: StreamTableSchemaValues,
): T => {
  const dropDuplicates = values.watermark?.dropDuplicates?.filter(
    (q) => !!q,
  ) as string[] | undefined;
  const watermark = values.streaming
    ? {
        eventTimeColumn: values.watermark?.eventTimeColumn || '',
        delayThreshold: values.watermark?.delayThreshold || '',
        dropDuplicates: dropDuplicates?.length ? dropDuplicates : undefined,
      }
    : undefined;

  return {
    name: values.name || '',
    streaming: values.streaming ?? null,
    watermark,
    alias: values.alias || undefined,
    joinType: values.joinType || undefined,
    joinExpr: values.joinExpr || undefined,
  } as T;
};
